import React from 'react';
import { useI18n, useSpringBigStore } from '@springbig/shared';
import { Box } from 'native-base';
import { Caption, H4 } from '~/shared/Typography';
import { useGeneralStyles, useGiftCardStyles } from '~/shared/styles';
import { format } from 'date-fns';

const TransactionHeader = () => {

    const gStyle = useGeneralStyles();
    const { member, merchant } = useSpringBigStore();
    const { card_text_color } = useGiftCardStyles();
    const { t } = useI18n();

    return (
        <Box bg={gStyle.button_background} borderBottomRadius={10} px={4} py={2}>
            {member?.first_name && member?.last_name && <Caption color={card_text_color} text={'giftCard.transactions.greeting'} textValues={[`${member?.first_name} ${member?.last_name}`]} />}
            <H4
                color={card_text_color}
                py={3}
                textAlign={'center'}
                fontSize={18}
            >
                { t('giftCard.transactions.title', [merchant?.gift_card_alias]) }
            </H4>
            <Caption color={card_text_color} text={'giftCard.transactions.lastUpdated'} textValues={[format(new Date(), 'MM-dd-yyyy')]} textAlign={'center'} fontSize={10} />
        </Box>
    );
};

export default TransactionHeader;
